function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  transform: "translate(0.3 0.3)"
}, /*#__PURE__*/React.createElement("g", {
  id: "no-wifi"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M0,8.5A8.271,8.271,0,0,1,8,0a8.271,8.271,0,0,1,8,8.5A8.271,8.271,0,0,1,8,17,8.271,8.271,0,0,1,0,8.5Z",
  transform: "translate(20 12)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.6
}), /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M11.783,10.732,1.269.217A.743.743,0,0,0,.217,1.269L10.731,11.783a.743.743,0,1,0,1.051-1.051Z",
  transform: "translate(22 15)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.6
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-2",
  "data-name": "Path",
  d: "M30.807,6.793a20.645,20.645,0,0,0-30.614,0,.709.709,0,0,0,.05,1.021.753.753,0,0,0,1.046-.049A19.315,19.315,0,0,1,15.5,1.444,19.315,19.315,0,0,1,29.711,7.763.746.746,0,0,0,30.259,8a.755.755,0,0,0,.5-.186A.709.709,0,0,0,30.807,6.793Z",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.6
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-3",
  "data-name": "Path",
  d: "M23.8,5.659A15.512,15.512,0,0,0,12,0,15.512,15.512,0,0,0,.2,5.659.831.831,0,0,0,.25,6.791a.732.732,0,0,0,1.074-.054A14.046,14.046,0,0,1,12,1.6,14.049,14.049,0,0,1,22.676,6.735a.734.734,0,0,0,1.074.056A.831.831,0,0,0,23.8,5.659Z",
  transform: "translate(4 6)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.6
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-4",
  "data-name": "Path",
  d: "M14.747,2.451A10.286,10.286,0,0,0,.2,3.691.8.8,0,0,0,.249,4.8a.742.742,0,0,0,1.072-.053A8.782,8.782,0,0,1,13.733,3.613a.742.742,0,0,0,1.072-.058A.8.8,0,0,0,14.747,2.451Z",
  transform: "translate(8 12)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.6
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape-2",
  "data-name": "Shape",
  d: "M0,4A3.78,3.78,0,0,1,3.5,0,3.78,3.78,0,0,1,7,4,3.78,3.78,0,0,1,3.5,8,3.78,3.78,0,0,1,0,4Z",
  transform: "translate(12 18)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.6
})));

function SvgDesktopI3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.6,
    height: 29.6,
    viewBox: "0 0 36.6 29.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopI3);
export default __webpack_public_path__ + "static/media/desktopI3.4a46956e.svg";
export { ForwardRef as ReactComponent };